export const SHOW_PLANS_MODAL = 'show-plans-modal';

export const triggerShowPlansModal = () => {
  const event = new CustomEvent(SHOW_PLANS_MODAL, {});
  window.dispatchEvent(event);
}
